
export const CALLS_ENDPOINTS = {
    GET_ALL: '/calls',
    CREATE: '/calls/create',
    GET_BY_ID: (id: string) => `/calls/${id}`,
    UPDATE: (id: string) => `/calls/${id}`,
    DELETE: (id: string) => `/calls/${id}`,
} as const;
